import React, { useEffect } from "react";
import Header from "../../layout/Header";
import HeroSection from "../../layout/HeroSection";
import Footer from "../../layout/Footer";
import { pageRoutes } from "../../routes/pageRoutes";
import SideBar from "./SideBar";
import OrderList from "./components/OrderList";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../redux/action/orderAction";
import Loader from "../../components/other/Loader";

const MyOrders = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.orderReducer);

  useEffect(() => {
    dispatch(fetchOrders());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"My Order"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "My Order", path: `${pageRoutes?.home}/` },
        ]}
      />
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            <SideBar />

            <OrderList />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyOrders;
